import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import LoadingButton from "@/Shared/LoadingButton";
import PublishCouponForm from "@/Pages/Coupons/Assets/PublishCouponForm";

const Edit = () => {
  const {coupon, discount_type} = usePage().props
  const {data, setData, errors, put, processing} = useForm({
    discount_type: coupon.discount_type || 1,
    value: coupon.value || 0.00,
    max_value: coupon.max_value || 0.00,
    min_amount: coupon.min_amount || 0.00,
    free_ship: coupon.free_ship || false,
    comments: coupon.comments || '',
    keywords: coupon.keywords || '',
    link_name: coupon.link_name || '',
    showonline: coupon.showonline || false,
  });

  function handleSubmit(e) {
    e.preventDefault();
    put(route('public.coupons.update', coupon.coupon_id).url());
  }


  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('public.coupons')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Published Coupons
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Edit Published Coupon
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <PublishCouponForm data={data} discount_type={discount_type} setData={setData} errors={errors}/>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Edit published coupon
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Edit.layout = page => <Layout title="Edit published coupon" children={page} />;

export default Edit;
